import { __assign } from "tslib";
import { useApiClient } from '@react/lib/api';
import { useMutation, useQueryClient } from 'react-query';
import { queryCacheKey } from '../constants';
import { useMessageContentLinkExtraction } from './useMessageContentLinkExtraction';
export function useMessageCreate() {
    var getContentLinkIds = useMessageContentLinkExtraction().getContentLinkIds;
    var queryClient = useQueryClient();
    var apiClient = useApiClient().portal;
    return useMutation(function createMessage(message) {
        var contentLinkIds = getContentLinkIds(message.content);
        return apiClient.createMessage(__assign(__assign({}, message), { metadata: { contentLinkIds: contentLinkIds } }));
    }, {
        onSuccess: function () {
            Object.keys(queryCacheKey).forEach(function (cacheKey) {
                queryClient.invalidateQueries(cacheKey);
            });
        },
    });
}
